export const mapAccreditationTooltipText = (
  accreditationBadgeTooltipText: string,
  accreditationName: string = 'accreditationName not provided'
) => {
  let mappedText = '';
  if (accreditationBadgeTooltipText) {
    mappedText = accreditationBadgeTooltipText.replace(
      '{{accreditation}}',
      accreditationName
    );
  } else {
    mappedText = accreditationName;
  }
  return mappedText;
};
